import { createStyles, Theme } from '@material-ui/core'

const HeaderWithIconStyles = (theme: Theme) => createStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    width: '20px',
    height: '20px',
    color: '#000',
    background: '#fff',
    borderRadius: 0,
  },
  iconWrapper: {

  },
  text: {
    marginLeft: theme.spacing(1) * 1.5,
    fontWeight: 500,
  },
})

export default HeaderWithIconStyles
